package one.healthium.profile.ui.update_weight

sealed interface UpdateWeightEvent {
    data object OnWeightUpdated : UpdateWeightEvent
}